<template>
    <div ref="lottieContainer" :style="{ width: containerWidth, height: containerHeight }"></div>
</template>
  
  <script>
  import lottie from 'lottie-web';
  import animationData from "../../../../src/assets/json/Animation.json";
  
  export default {
  data() {
    return {
      containerWidth: '350px',
      containerHeight: '350px'
    };
  },
    mounted() {
      this.initAnimation();
    },
    methods: {
      initAnimation() {
        const container = this.$refs.lottieContainer;
        if (container) {
          lottie.loadAnimation({
            container,
            renderer: 'svg', // Use 'canvas' or 'svg' based on your preference
            autoplay: true,
            animationData 
          });
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add your styles here if needed */
  </style>
  


// WEBPACK FOOTER //
// src/components/Dashboard/Layout/CouponAnimation.vue